import { LawYear } from "@/types/salary";
import { laws } from "@/data-source";
const calculateInsuranceWage = (grossSalary: number, lawYear: LawYear) => {
    return Math.max(
        laws[lawYear].MinGrossSalary,
        Math.min(grossSalary, laws[lawYear].MaxGrossSalary)
    );
};

export { calculateInsuranceWage };
